class FireBase {
  static EVENTS = {
    FIRST_LOGIN: 'First_Login',
    PURCHASE: 'Purchase',
    SUCCESS_CARD_TOP_UP: 'Success_Card_Top_Up',
    SUCCESS_SAVED_CARD_TOP_UP: 'Success_Saved_Card_Top_Up',
    TAP_ON_ANY_PRO_IN_FIND_PRO: 'Tap_on_any_Pro_in_Find_a_Pro',
    TAP_SIGN_IN: 'Tap_Sign_in',
  }

  static initialise() {
    /**
     * @property {{ analytics: Function, initializeApp: Function }} firebase
     */
    firebase.initializeApp({
      apiKey: process.env.PREACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.PREACT_APP_FIREBASE_AUTH_DOMAIN,
      databaseURL: process.env.PREACT_APP_FIREBASE_DATA_BASE_URL,
      projectId: process.env.PREACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.PREACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.PREACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.PREACT_APP_FIREBASE_APP_ID,
      measurementId: process.env.PREACT_APP_FIREBASE_MEASURMENT_ID,
    });

    firebase.analytics();
  }

  /**
   *
   * @param {string} eventType
   * @param {Object} [eventParams]
   */
  static logEvent(eventType, eventParams) {
    try {
      /**
       * @property {{ analytics: Function }} firebase
       */
      window.firebase.analytics().logEvent(eventType, eventParams);
    } catch (error) {
      throw new Error(`Firebase event "${eventType}" isn't processed!`);
    }
  }

  static setUserId(id) {
    try {
      /**
       * @property {{ analytics: Function }} firebase
       */
      window.firebase.analytics().setUserId(id);
    } catch (error) {
      throw new Error(`Firebase cannot set user id '${id}'`);
    }
  }
}

export default FireBase;



// WEBPACK FOOTER //
// ./services/FireBase.js